import { render, staticRenderFns } from "./RequestPage.vue?vue&type=template&id=5317393a&lang=pug&"
import script from "./RequestPage.vue?vue&type=script&lang=js&"
export * from "./RequestPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports